import $ from 'jquery'

const ajaxQueue = $({});

$.ajaxQueue = function(ajaxOpts) {
    var oldComplete = ajaxOpts.complete;
    ajaxQueue.queue(function(next) {
        ajaxOpts.complete = function() {
            if (oldComplete) oldComplete.apply(this, arguments);
            next();
        };
        $(document).ready(function() {
            $.ajax(ajaxOpts);
        });
    });
};

export const infoBoxModals = (params, returnHTML) => {
    var myCallback = () => {};
    let espotChoice = params.espotChoice;
    var espotName = '';
    if (espotChoice === 'shipping') {
        espotName = 'ES_ORDER_SHIPPING_INFO';
    }
    if (espotChoice === 'returns') {
        espotName = 'ES_ORDER_RETURNS_INFO';
    }
    if (espotChoice === 'purchaseInfo') {
        espotName = 'ES_PURCHASE_STATUS_MODAL_INFO';
    }
    if (espotChoice === 'whatsThis') {
        espotName = 'ES_WHATS_THIS_MODAL';
    }
    if(params.espotName!= undefined){
    	espotName = params.espotName;
    }
    $.ajaxQueue({
        cache: true,
        type: "GET",
        dataType: "json",
        url: "/webapp/wcs/stores/servlet/NonCacheESpot",
        data: "emsName=" + espotName + "&maxNumDisp=1&storeId=301&catalogId=301&langId=-1",
        success: function (json) {
            let successResp = json.JSON,
                infoBoxHTML = successResp.eSpotContent0 == null ? "" : successResp.eSpotContent0;
            returnHTML(infoBoxHTML, myCallback);
            return false;
        }
    });
}